// SaaS API client — Phase 1.
// Mirrors testingLabApi.js pattern: relative /api/saas, auth via global fetch interceptor.

const API = '/api/saas';

async function jfetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    credentials: 'include',
    ...options,
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      detail = j.detail || JSON.stringify(j);
    } catch { /* ignore */ }
    const err = new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const saas = {
  // Public
  listPlans: () => jfetch('/plans'),

  // Current user
  myPlan: () => jfetch('/me/plan'),
  myModuleState: (moduleKey) => jfetch(`/me/module-state/${moduleKey}`),

  // Billing
  createCheckout: (planKey) => jfetch('/billing/checkout', {
    method: 'POST',
    body: JSON.stringify({
      plan_key: planKey,
      origin_url: window.location.origin,
    }),
  }),
  checkoutStatus: (sessionId) => jfetch(`/billing/checkout-status/${sessionId}`),
  openPortal: () => jfetch('/billing/portal', {
    method: 'POST',
    body: JSON.stringify({
      return_url: `${window.location.origin}/billing`,
    }),
  }),

  // Super-admin: identity
  identityInspect: ({ email, user_id, person_id }) => {
    const params = new URLSearchParams();
    if (email) params.set('email', email);
    if (user_id) params.set('user_id', user_id);
    if (person_id) params.set('person_id', person_id);
    return jfetch(`/admin/identity/inspect?${params.toString()}`);
  },
  identityReset: (body) => jfetch('/admin/identity/reset', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  identityReinvite: (body) => jfetch('/admin/identity/reinvite', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  identityAudit: (limit = 100) => jfetch(`/admin/identity/audit?limit=${limit}`),

  // Super-admin: billing
  adminSubscriptions: (limit = 200) => jfetch(`/admin/subscriptions?limit=${limit}`),
  adminBillingEvents: (limit = 100) => jfetch(`/admin/billing-events?limit=${limit}`),
  adminSeedPlans: () => jfetch('/admin/seed-plans', { method: 'POST' }),
};

export default saas;
